module.exports = __webpack_public_path__ + "img/11.088cea98.png";